import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../comm_stores";
import { IFUsers } from "../interface/IFuser";

interface IFuserSlice{
    orign_users_array:IFUsers[],
    users_array_with_superdoctor:IFUsers[]
}

const initialState:IFuserSlice = {
    orign_users_array:[],
    users_array_with_superdoctor:[]
}

export const usersArraySlice = createSlice({
    name:"usersArray",
    initialState,
    reducers:{
        ADD_USERS_ARRAY:(state, action:PayloadAction<IFUsers[]>)=>{
            let _acc = localStorage.getItem("currentAccount") || sessionStorage.getItem("currentAccount")
            // let _userInfo = JSON.parse(localStorage.getItem(_acc) || sessionStorage.getItem(_acc))
            let _userInfoArr = _acc!==null?localStorage.getItem(_acc):""
            let _userInfo:IFUsers = _userInfoArr?JSON.parse(_userInfoArr):""
            let _id = _userInfo.id
            if(action.payload!==null){
                state.users_array_with_superdoctor = action.payload
                let _users = action.payload.filter(user=>user.role==="doctor") || []
                if(_userInfo.role==="superdoctor"){ state.orign_users_array=_users }
                else if (_userInfo.role==="admin"){ state.orign_users_array=action.payload }
                else{ state.orign_users_array=action.payload.filter(e=>e.id === _id) }
            }
        },
        CLEAR_USER_ARRAY:(state)=>{ state.orign_users_array = [] },
    },

})

export const {
    ADD_USERS_ARRAY,
    CLEAR_USER_ARRAY,
    // ADD_ALL_USER_ARRAY
} = usersArraySlice.actions

// export default usersArraySlice.reducer
export const selectOrder = (state: RootState) => state.store_users

export default usersArraySlice.reducer